;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();export const fragment = /* GraphQL */ `
    fragment CardSimpleFragment on CardSimple {
        image {
            ...Asset
        }
        eyebrow
        title
        link {
            ...EntryLink
        }
    }
`;
